import styled from "styled-components";

const c = {
  black: "#1e1e1e",
  white: "#ffffff",
  pink: "#fc9ac4",
  pinkSoft: "rgba(252,154,196,0.18)",
  gold: "#c9a227",
  goldSoft: "rgba(201,162,39,0.22)",
  text: "#2a2a2a",
  muted: "rgba(42,42,42,0.72)",
  line: "rgba(0,0,0,0.08)",
};

export const PageWrap = styled.main`
  width: 100%;
  min-height: 100vh;
  background: #fffafc;
  color: ${c.text};
  padding: 150px 20px 90px;
`;

export const Section = styled.section`
  width: min(900px, 100%);
  margin: 0 auto 44px;
`;

export const Title = styled.h1`
  margin: 0 0 18px;
  font-size: clamp(38px, 6vw, 72px);
  line-height: 0.95;
  font-weight: 500;
  letter-spacing: -0.05em;
  color: ${c.black};
  text-align: center;
`;

export const Subtitle = styled.p`
  max-width: 720px;
  margin: 0 auto;
  font-size: clamp(16px, 2vw, 20px);
  line-height: 1.8;
  color: ${c.muted};
  text-align: center;
`;

export const H2 = styled.h2`
  margin: 0 0 16px;
  font-size: clamp(24px, 3vw, 36px);
  line-height: 1.15;
  font-weight: 500;
  letter-spacing: -0.03em;
  color: ${c.black};
`;

export const H3 = styled.h3`
  margin: 28px 0 10px;
  font-size: clamp(18px, 2vw, 24px);
  line-height: 1.25;
  font-weight: 600;
  color: ${c.black};
`;

export const P = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 1.85;
  color: ${c.muted};
`;

export const Ul = styled.ul`
  margin: 12px 0 0;
  padding-left: 22px;

  li {
    margin-bottom: 8px;
    font-size: 16px;
    line-height: 1.75;
    color: ${c.muted};

    &::marker {
      color: ${c.pink};
    }
  }
`;

export const Ornament = styled.div`
  width: min(900px, 100%);
  height: 1px;
  margin: 46px auto;
  background: linear-gradient(
    90deg,
    transparent,
    ${c.goldSoft},
    ${c.pinkSoft},
    ${c.goldSoft},
    transparent
  );
`;
